module.exports = __webpack_public_path__ + "img/new-tab.8ea63051.svg";